import { useEffect } from 'react';
import { UseConfirmDialogReturn } from './types';

/**
 * 確認ダイアログのロジックを管理するカスタムフック
 * @param isOpen ダイアログが開いているかどうか
 * @param onCancel キャンセル時のコールバック
 * @returns ダイアログ操作に関する関数群
 */
export const useConfirmDialog = (
  isOpen: boolean,
  onCancel: () => void
): UseConfirmDialogReturn => {
  // ESCキーでダイアログを閉じる
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onCancel();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      // ダイアログが開いている間はスクロールを無効化
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      // コンポーネントのアンマウント時にスクロールを再度有効化
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onCancel]);

  return {
    handleKeyDown: (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onCancel();
      }
    }
  };
}; 